import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import projectWebanalyticsRoutes from 'router/routes/projects/webanalytics';
import projectSettingsRoutes from 'router/routes/projects/settings';
import projectToolsRoutes from 'router/routes/projects/tools/tools';
import projectOrdersRoutes from 'router/routes/projects/orders';
import projectBookingRoutes from 'router/routes/projects/booking';
import projectPlacementsRoutes from 'router/routes/projects/placements';
import projectStatisticsRoutes from 'router/routes/projects/statistics';
import projectReportsRoutes from 'router/routes/projects/reports';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import projectMarkupsRoutes from 'router/routes/projects/markups';
import store from 'store';
import translation from 'translation';
import ProjectNestedPage from 'layouts/nested/project/ProjectNestedPage';
import projectConnectionsRoutes from 'router/routes/projects/connections';

const projectsRoutes = [
  {
    path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)',
    component: ProjectNestedPage,
    meta: {
      nestedName: 'projectDetails_nested',
      routeName: {
        segmentName: () => store.getters['projects/currentProject'].name
      },
      permissions: ['READ_PROJECT']
    },
    children: [
      {
        path: '',
        name: 'projectDetails',
        component: () => asyncLoadView(import('pages/dashboards/ProjectDashboardPage/ProjectDashboardPage')),
        props: routeArgsToInt
      },

      ...projectOrdersRoutes,
      ...projectPlacementsRoutes,
      ...projectBookingRoutes,
      ...projectStatisticsRoutes,
      ...projectReportsRoutes,

      {
        path: 'history',
        name: 'projectHistory',
        meta: {
          routeName: {
            segmentName: () => translation.tr('History')
          },
          permissions: ['READ_PROJECT_HISTORY']
        },
        component: wrapLegacyRoute('historyController', 'projectHistory')
      },

      ...projectMarkupsRoutes,

      ...projectSettingsRoutes,

      // Legacy web analytics routes
      ...projectWebanalyticsRoutes,

      ...projectToolsRoutes,

      ...projectConnectionsRoutes
    ]
  }
];

export default projectsRoutes;
